module.exports = __webpack_public_path__ + "img/nezha.08f81b24.gif";